import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bookmark",
  "use": "bookmark-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"bookmark\"><path d=\"M7.78 12.09L3.5 14.197V3A1.5 1.5 0 015 1.5h6A1.5 1.5 0 0112.5 3v11.197L8.22 12.09 8 11.98l-.22.109z\" stroke=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol